export function selectDropdownOption(state, payload) {
  return {
    ...state,
    currentSection: setDrodownValueInCurrentSection(
      state.currentSection,
      payload
    ),
  };
}

function setDrodownValueInCurrentSection(currentSection, payload) {
  return {
    ...currentSection,
    components: setDrodownValueInComponents(currentSection.components, payload),
  };
}

function setDrodownValueInComponents(components, payload) {
  return components.map((component) => {
    if (component.id === payload.componentID) {
      component = setDropdownValueInDDQComponent(component, payload);
    }
    return component;
  });
}

function setDropdownValueInDDQComponent(DDQComponent, payload) {
  const setDropdownValueInAnswerSteps = (step) => {
    const updatedStep = {...step};
    if (updatedStep.value === payload.name) {
      updatedStep.droppedId = payload.value;
      updatedStep.showFeedback = false;
    }
    return updatedStep;
  };
  return {
    ...DDQComponent,
    answerSteps: DDQComponent.answerSteps.map(setDropdownValueInAnswerSteps),
  };
}
